export default __webpack_public_path__ + "static/media/profile2.df984046.png";